import { BlockPhotoUploadedEntityHydrated } from "@jackfruit/common"
import React, { lazy, Suspense } from "react"
import { useUploads } from "~/hooks/useUploads"

const PhotosUploadedBlock = lazy(() => import("./PhotosUploadedBlock"))

interface Props {
  config: BlockPhotoUploadedEntityHydrated
}

const PhotosUploadedBlockWrapper: React.FC<Props> = ({ config }) => {
  const { uploads } = useUploads()

  if (uploads.length === 0) {
    return null
  }

  return (
    <Suspense>
      <PhotosUploadedBlock config={config} />
    </Suspense>
  )
}

export default PhotosUploadedBlockWrapper
